import type { Material } from '../../types/progression'

/*
 * Textos editoriales de las misiones de evolución. Niveles, Zen, objetivos, cantidades,
 * clases, misiones previas y drops salen de los archivos de misiones de Vanguard, no de aquí.
 * Orden y nombres de Marlon según la guía oficial de Webzen:
 * https://muonline.webzen.com/en/gameinfo/guide/detail/83
 */

export const MARLON_REFERENCE_URL = 'https://muonline.webzen.com/en/gameinfo/guide/detail/83'

export const sebina = {
  questIds: [0, 1],
  scroll: {
    id: 'scroll-emperor',
    itemId: '14,23@0',
    gameName: 'Scroll of the Emperor',
    altNames: ['Scroll of Emperor'],
    esName: 'Pergamino del Emperador',
    qtyStatus: 'documentado',
  } as Material,
  /** Misión 0. */
  stepsPart1: [
    'Habla con Sebina the Priest, paga el Zen indicado y acepta la primera parte.',
    'Consigue Scroll of the Emperor con la misión aceptada.',
    'Regresa con Sebina y entrégalo.',
  ],
  /** Misión 1 (requiere la 0 terminada). */
  stepsPart2: [
    'Habla de nuevo con Sebina, paga el Zen indicado y acepta la segunda parte.',
    'Consigue el objeto de tu clase con la misión aceptada.',
    'Regresa con Sebina y entrégalo para completar la evolución a segunda clase.',
  ],
  issues: [
    'Los objetos de esta misión solo caen con la misión aceptada, si tu clase puede hacerla y si no llevas ya ese objeto en el inventario. Si no te sale, revisa esas condiciones antes de pensar que es mala suerte.',
    'En la segunda parte cada clase busca un solo objeto: Broken Sword (Dark Knight), Soul Shard of Wizard (Dark Wizard), Tear of Elf (Fairy Elf) o Abyssal Eye (Summoner).',
    'Magic Gladiator, Dark Lord y Rage Fighter no realizan esta misión ni necesitan sus materiales.',
    'Si cancelas la misión, volver a aceptarla tiene el mismo coste en Zen indicado arriba.',
  ],
}

export const marlon = {
  questIds: [2, 3],
  /** Misión 2 (requiere la 1 terminada). */
  steps: [
    'Con la segunda clase y la segunda parte de Sebina terminada, habla con Marlon.',
    'Paga el Zen indicado y acepta la misión.',
    'Consigue Ring of Honor con la misión aceptada.',
    'Regresa con Marlon y entrégalo.',
  ],
  /** Misión 3 (requiere la 2 terminada, solo Blade Knight). */
  comboSteps: [
    'Con la primera parte de Marlon terminada, habla de nuevo con Marlon y acepta la parte adicional.',
    'Consigue Dark Stone con la misión aceptada.',
    'Regresa con Marlon y entrégala para completar la misión.',
  ],
}

export const thirdEvolution = {
  questIds: [4, 5, 6],
  npc: 'Apostle Devin',
  stage1: {
    /** Identidades usadas por el buscador. Las cantidades salen de quest_objectives.csv. */
    materials: [
      { id: 'flame-dbk', itemId: '14,65', gameName: 'Death-beam Knight Flame', altNames: ['Flame of Death Beam Knight'], esName: 'Llama del Death Beam Knight', qtyStatus: 'documentado' },
      { id: 'horn-hell-maine', itemId: '14,66', gameName: 'Hell-Miner Horn', altNames: ['Horn of Hell Maine'], esName: 'Cuerno de Hell Maine', qtyStatus: 'documentado' },
      { id: 'feather-phoenix', itemId: '14,67', gameName: 'Dark Phoenix Feather', altNames: ['Feather of Phoenix of Darkness'], esName: 'Pluma del Fénix de la Oscuridad', qtyStatus: 'documentado' },
    ] as Material[],
    steps: ['Habla con Devin, paga el Zen indicado y acepta la misión.', 'Consigue los tres materiales con la misión aceptada.', 'Regresa con Devin y entrégalos.'],
  },
  stage2: {
    map: 'Barracks',
    steps: ['Acepta la siguiente misión con Devin.', 'Entra a Barracks.', 'Derrota a los monstruos indicados en la cantidad exigida.', 'Regresa con Devin.'],
  },
  stage3: {
    map: 'Refuge',
    steps: ['Acepta la siguiente misión con Devin.', 'Avanza desde Barracks hasta Refuge.', 'Derrota al monstruo indicado.', 'Regresa con Devin.'],
  },
}
